<template>
    <i
        style="font-size: 18px; color: rgb(var(--red))"
        class="iconsax"
        icon-name="x-square"></i>
</template>
